<template>
  <div class="home-div">
    <SideBar />
    <div class="music-container">
      <!-- 标题文字 -->
      <div class="music-title">一曲肝肠断、天涯何处觅知音</div>

      <!-- 音乐列表 -->
      <div class="music-list">
        <div
          class="music-item"
          v-for="(item, index) in musicList"
          :key="index"
          @click="playMusic(item.src, item.title)"
        >
          <!-- 圆形封面 -->
          <div class="music-cover">
            <img :src="item.image" alt="封面" />
          </div>
          <!-- 歌曲名 -->
          <div class="music-name">{{ item.title }}</div>
        </div>
      </div>

      <!-- 隐藏的音乐播放器 -->
      <audio ref="musicPlayer" id="musicPlayer"></audio>
    </div>

    <BottomTip />
  </div>
</template>

<script>
import SideBar from '@/components/menu/SideBar.vue';
import BottomTip from '@/components/menu/BottomTip.vue';
import { Message } from 'element-ui';
import { getMusicListInfo } from '@/api/music';
import config from '@/utils/Config';

export default {
  name: 'Music',
  components: {
    SideBar,
    BottomTip,
  },
  data() {
    return {
      // 音乐列表（全部使用同一地址）
      musicList: [],
      // 当前播放状态
      currentAudio: null,
    };
  },
  mounted() {
    this.fetchMusicList();
  },
  methods: {
    // 播放音乐
    playMusic(url, title) {
      const audio = this.$refs.musicPlayer;
      if (!audio) return;

      // 如果正在播放同一首 → 暂停
      if (audio.src === url && !audio.paused) {
        audio.pause();
        Message.info('音乐已暂停');
        return;
      }

      // 播放新音乐
      audio.src = url;
      audio.play();
      Message.success('正在播放：' + title);
    },
    // 从后端获取音乐列表
    async fetchMusicList() {
      this.loading = true;
      this.error = '';

      try {
        const response = await getMusicListInfo();
        if (response.data && Array.isArray(response.data)) {
          this.musicList = response.data.map(item => {
            return {
              title: item.title,
              artist: item.artist,
              src: config.BASE_FILE_URL + item.url,
              image: config.BASE_FILE_URL + item.img
            };
          });
        } else {
          this.error = '获取音乐列表失败';
        }
      } catch (error) {
        console.error('获取音乐列表错误:', error);
        this.error = '无法连接到音乐服务器';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* 页面容器 */
.home-div {
  width: 100%;
  min-height: calc(100vh - 60px);
  padding-top: 60px;
  background: transparent !important;
  overflow: hidden;
}

/* 整体布局居中 */
.music-container {
  width: 85%;
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 110px);
}

/* 标题样式 */
.music-title {
  font-size: 28px;
  font-weight: 500;
  color: #ffffff;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.3);
  margin-bottom: 40px;
  letter-spacing: 2px;
  text-align: center;
}

/* 音乐列表布局 */
.music-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 30px;
  width: 100%;
}

/* 音乐卡片 */
.music-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* 圆形封面容器 */
.music-cover {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.15);
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

/* 图片 */
.music-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.8s linear;
}

/* 悬停旋转 + 发光 */
.music-item:hover .music-cover {
  box-shadow: 0 0 30px rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
}
.music-item:hover .music-cover img {
  transform: rotate(360deg);
}

/* 歌曲名 */
.music-name {
  font-size: 16px;
  color: #ffffff;
  text-shadow: 0 0 3px rgba(0, 0, 0, 0.7);
  text-align: center;
}

/* 音频元素隐藏 */
#audioPlayer {
  display: none;
}

/* 移动端适配 */
@media only screen and (max-width: 768px) {
  .music-title {
    font-size: 22px;
  }
  .music-list {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 20px;
  }
  .music-cover {
    width: 100px;
    height: 100px;
  }
}
</style>